import { Component, OnInit } from '@angular/core';
import { StateService } from '../../../core/services/state.service';
import { DataTaskService } from '../../../core/services/data-task.service';
import { Item } from '../../../core/components/listbox/listbox.component';

@Component({
  selector: 'tt-check-in',
  templateUrl: './check-in.component.html',
  styleUrls: ['./check-in.component.css']
})
export class CheckInComponent implements OnInit {
    argType;

    argValue;

    checkInKeyno;

    public selectedBgCheckInPersonTypeSelection: string = 'CHECKIN_PERSONTYPE_EXTERNAL';

    public edit?: Edit;

    public itemsListSkillsCertificates: Item[] = [];

    public saving = false;

    public checkingOut = false;

    constructor(private stateService: StateService, private datatask: DataTaskService) {
        this.argType = this.stateService.getStateParams()['argtype'];
        this.argValue = this.stateService.getStateParams()['argvalue'];
        this.checkInKeyno = this.stateService.getStateParams()['checkin_keyno'];
    }

    private async loadEdit() {
        if (!!this.argType && !!this.argValue && !!this.checkInKeyno) {
            this.edit = (await this.datatask.Post(509, {
                argtype: this.argType,
                argvalue: this.argValue,
                checkin_keyno: this.checkInKeyno
            }))[0];
        }
    }

    private async loadSkillsCertificates() {
        if (!this.edit) return;

        return this.itemsListSkillsCertificates = await this.datatask.Post(2506, { labour_no: this.edit.labour_no });
    }

    public async saveChanges() {
        if (!!this.edit) {
            try {
                this.saving = true;

                await this.datatask.Post(510, this.edit);

                this.stateService.back();
            } finally {
                this.saving = false;
            }
        }
    }

    public async checkInOut() {
        if (!!this.edit) {
            try {
                this.checkingOut = true;

                await this.datatask.Post(511, this.edit);

                this.stateService.back();
            } finally {
                this.checkingOut = false;
            }
        }
    }

    private async init() {
        await this.loadEdit();
        this.loadSkillsCertificates();
    }

    ngOnInit() {
        this.init();
    }
}

interface Edit {
    checkin_keyno: string;
    argtype: string;
    argvalue: string;
    external_name: string;
    external_cellphone: string;
    external_company: string;
    personname: string;
    persontype: string;
    personcellphone: string;
    checkin_dt_txt: string;
    latitude: string;
    longitude: string;
    accurancy: string;
    pers_no: string;
    external_identification_card_no1: string;
    labour_no: string;
}
